import script from "./RangeTool.vue?vue&type=script&lang=js"
export * from "./RangeTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__